<template>
  <div>
<!--    Add Slider to handle multiple images-->
    <b-carousel
      id="carousel-1"
      :interval="4000">
      <b-carousel-slide v-for="url in thumbURLs" :key="url" :img-src="url" class="rounded-0" alt="Media Thumb" ></b-carousel-slide>
    </b-carousel>
<!--    <div v-for="url in thumbURLs" :key="url">-->
<!--      <b-card-img :src="url" alt="Media Thumb" class="rounded-0"></b-card-img>-->
<!--    </div>-->
  </div>

</template>

<script>
import { derivativeThumbsForEntity } from '#/models/entities/entity';

export default {
  props: {
    entity: {
      required: true,
    },
  },
  computed: {
    thumbURLs() {
      return derivativeThumbsForEntity(this.entity);
    },
  },
};
</script>

<style scoped>

</style>
